import React from 'react';
import './index.scss';


//api
import { api } from '../../../functions/api';

//material ui
import { Grid, Paper } from '@material-ui/core';

//custom components
import CustomInput from '../../../components/basic/input';
// import CustomButton from '../../../components/basic/CustomButton';

//other libraries
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
// import Icon from '@mdi/react'
// import { mdiContentSaveOutline } from '@mdi/js'

const TIMEOUT = 500;

@inject('internal')
@inject('translate')
@observer
export default class BasicInfo extends React.Component {
    
    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    handleChange = () => {
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.updateData()
        }, TIMEOUT)
    }

    updateData = async () => {
        let client_name = this.client_name.state.value;
        let street_name = this.street_name.state.value;
        let street_no = this.street_no.state.value;
        let city = this.city.state.value;
        let zip = this.zip.state.value;
        let country = this.country.state.value;
        let id_no = this.id_no.state.value;
        let id_vat = this.id_vat.state.value;
        let id_tax = this.id_tax.state.value;

        let update_global_settings = await api({
            method:'post',
            url:'global-settings',
            authorization: this.props.internal.user.access_token,
            params: {
                client_name: client_name,
                address: {
                    street_name: street_name,
                    street_no: street_no,
                    city: city,
                    zip: zip,
                    country: country,
                },
                id_no: id_no,
                id_vat: id_vat,
                id_tax: id_tax,

                //vyplname v dalsom tabe
                // phone_primary: toJS(this.props.internal.dataForSimpeTable.phone_primary),
                // email_primary: toJS(this.props.internal.dataForSimpeTable.email_primary),
                // email_secondary: toJS(this.props.internal.dataForSimpeTable.email_secondary),
                // project_name: toJS(this.props.internal.dataForSimpeTable.project_name),
                // seo_title: toJS(this.props.internal.dataForSimpeTable.seo_title),
            }
        })

        if(update_global_settings.success === true) {
            this.props.internal.setDataForSimpeTable(update_global_settings.data.data);
            this.props.internal.setSnackbar(update_global_settings.data.message, true)
        }
        else {
            let resultError = "";
            if(update_global_settings.data.data.errors) {
                for(let error in update_global_settings.data.data.errors){
                    resultError += update_global_settings.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar(resultError, true)
        }
    }

    render() {
        return (
            <Paper className={'settings-basic'}>
            
                <Grid container spacing={16} >
                    {/* <Grid item xs={12} className={'save-btn'} >
                        <CustomButton
                            // progressBar={this.state.loading}
                            onClick={this.updateData}
                            mystyle={'btn-orange-bg border-radius-18'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                            >
                                <Icon path={mdiContentSaveOutline} size={1}  />
                            </CustomButton>
                        </Grid> */}
                    <Grid item sm={12} md={6} lg={4} className={'column'}>
                        <CustomInput
                            ref={ref => this.client_name = ref}
                            text={this.props.translate.i18n.MODULES.SETTINGS.COMPANY_NAME}
                            value={toJS(this.props.internal.dataForSimpeTable.client_name)}
                            id={'client_name'}
                            className={"w-100"}
                            change={this.handleChange}
                        />
                    </Grid>
                    <Grid item sm={12} md={6} lg={8}>
                        <Grid container spacing={16}>
                            <Grid item sm={12} md={12} lg={6} className={'column'}>
                                <Grid container direction="column">
                                    <Grid item>
                                        <CustomInput
                                            ref={ref => this.street_name = ref}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                                            value={toJS(this.props.internal.dataForSimpeTable.address.street_name)}
                                            id={'street_name'}
                                            className={"w-100"}
                                            change={this.handleChange}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <CustomInput
                                            ref={ref => this.street_no = ref}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.STREET_NO}
                                            value={toJS(this.props.internal.dataForSimpeTable.address.street_no)}
                                            id={'street_no'}
                                            className={"w-100"}
                                            change={this.handleChange}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <CustomInput
                                            ref={ref => this.zip = ref}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                                            value={toJS(this.props.internal.dataForSimpeTable.address.zip)}
                                            id={'zip'}
                                            className={"w-100"}
                                            change={this.handleChange}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <CustomInput
                                            ref={ref => this.city = ref}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                                            value={toJS(this.props.internal.dataForSimpeTable.address.city)}
                                            id={'city'}
                                            className={"w-100"}
                                            change={this.handleChange}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <CustomInput
                                            ref={ref => this.country = ref}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}
                                            value={toJS(this.props.internal.dataForSimpeTable.address.country)}
                                            id={'country'}
                                            className={"w-100"}
                                            change={this.handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={12} lg={6} className={'column'}>
                                <Grid container direction="column">
                                    <Grid item>
                                        <CustomInput
                                            ref={ref => this.id_no = ref}
                                            text={this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.ICO}
                                            value={toJS(this.props.internal.dataForSimpeTable.id_no)}
                                            id={'id_no'}
                                            className={"w-100"}
                                            change={this.handleChange}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <CustomInput
                                            ref={ref => this.id_vat = ref}
                                            text={this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.IC_DPH}
                                            value={toJS(this.props.internal.dataForSimpeTable.id_vat)}
                                            id={'id_vat'}
                                            className={"w-100"}
                                            change={this.handleChange}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <CustomInput
                                            ref={ref => this.id_tax = ref}
                                            text={this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.DIC}
                                            value={toJS(this.props.internal.dataForSimpeTable.id_tax)}
                                            id={'id_tax'}
                                            className={"w-100"}
                                            change={this.handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/settings/basic/index.js